export default __webpack_public_path__ + "static/media/otp-illustration.d89b4bca.png";